export type ThemeSelection = 'system' | 'light' | 'dark';
export type ResolvedTheme = 'light' | 'dark';

export const THEME_STORAGE_KEY = 'chattenger:web:theme-selection';
export const DEFAULT_THEME_SELECTION: ThemeSelection = 'dark';

export const resolveThemePreference = ({ selection, prefersDark }: { selection: ThemeSelection; prefersDark: boolean }): ResolvedTheme => {
    if (selection === 'light') {
        return 'light';
    }

    if (selection === 'dark') {
        return 'dark';
    }

    return prefersDark ? 'dark' : 'light';
};

export const buildThemeBootstrapScript = () =>
    `
(() => {
    const storageKey = '${THEME_STORAGE_KEY}';
    const root = document.documentElement;
    const readStoredTheme = () => {
        try {
            const value = window.localStorage.getItem(storageKey);
            return value === 'light' || value === 'dark' || value === 'system' ? value : '${DEFAULT_THEME_SELECTION}';
        } catch (_error) {
            return '${DEFAULT_THEME_SELECTION}';
        }
    };
    const resolveTheme = (selection) => {
        const prefersDark = typeof window.matchMedia === 'function' && window.matchMedia('(prefers-color-scheme: dark)').matches;
        if (selection === 'light' || selection === 'dark') return selection;
        return prefersDark ? 'dark' : 'light';
    };
    const selection = readStoredTheme();
    const resolved = resolveTheme(selection);
    root.dataset.themeSelection = selection;
    root.dataset.theme = resolved;
    root.style.colorScheme = resolved;
})();
`.trim();
